import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import LayerUtils from "@vision/core-map-api/src/utils/LayerUtils";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

export abstract class WmsLayerResultsDialogComponent {
  isAuthRequired: boolean = false;

  hide = true;

  formatPercentLabel = (value: number) => `${value}%`;

  layers: any[];

  url: string;

  username: string = "";

  password: string = "";

  newLayerForm = new FormGroup({
    newLayerName: new FormControl(""),
    newLayerOpacity: new FormControl(100),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected geoJSONDatabaseService: GeoJSONDatabaseService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    this.url = data.url;
    this.username = data.username;
    this.password = data.password;
    this.isAuthRequired = data.isAuthRequired;
    this.layers = data.layers;
  }

  changeCheckLayer(checked: boolean, layer: any) {
    layer.checked = checked;
  }

  anyChecked(): boolean {
    if (this.layers) {
      return this.layers.some((layer) => layer.checked !== undefined && layer.checked);
    }

    return false;
  }

  addWMSLayers() {
    const url = LayerUtils.removeParam("request", this.url);

    let extraParams;
    const layerNames = [];
    this.layers
      .filter((layer) => layer.checked)
      .map((layer) => {
        layerNames.push(layer.Name);
        return layer;
      });
    if (this.isAuthRequired && this.username.length > 0 && this.password.length > 0) {
      extraParams = {
        URL_ORIGIN: url,
        USERNAME: this.username,
        PASSWORD: this.password,
      };
    }
    const wmsStyle = "";
    const layersText = layerNames.join(",");
    let name = this.newLayerForm.get("newLayerName").value;
    let opacity = this.newLayerForm.get("newLayerOpacity").value;
    if (name.length === 0) {
      name = "Custom WMS Layer";
    }
    if (!opacity) {
      opacity = 1;
    } else {
      opacity /= 100;
    }

    const layer = {
      source: ViewerConstants.SOURCE_NAME.WMS,
      url,
      extraParams,
      removable: true,
      editable: false,
      owner: true,
      layer: layersText,
      isBase: false,
      opacity,
      visible: true,
      realId: `${name.replace(/ /g, "")}_${LayerUtils.layerGuid()}`,
      id: `${name}_${LayerUtils.layerGuid()}`,
      name,
      panelInclude: true,
      style: wmsStyle,
      order: ViewerConstants.USER_LAYER_BASE_ZINDEX,
      userId: this.viewerConfigurationService.getViewerConfiguration().userId,
    };

    const layerToSave = LayerUtils.processLayer(layer) as unknown as Viewerlayer;
    this.saveLayer(layerToSave);
    this.matDialog.closeAll();
  }

  abstract saveLayer(layer: Viewerlayer);
}
